import CommonInformationDetail from '../../../common/pages/secure/InformationDetail'
import Config from '../../../Config'

class InformationDetail extends CommonInformationDetail {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyUserApiUrl.systemSettings
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
    this.isShowingEditButton = false
    this.isShowingDeleteButton = false
  }
}

export default InformationDetail



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/InformationDetail.js